import { EffectCallback, useEffect } from 'react'

export const useEffectOnce = (effect: EffectCallback) => {
  return useEffect(() => {
    return effect()
    //eslint-disable-next-line
  }, [])
}
